import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageSeoBreadcrumbsResolver } from './page-seo-breadcrumbs.resolver';
import { PageSeoComponent } from './page-seo.component';

const routes: Routes = [
  {
    path: ':id',
    component: PageSeoComponent,
    data: {
      title: `Concilio, la plateforme d'accompagnement santé`,
      description: 'Détails Page',
      keywords: 'b2b, concilio, page',
      breadcrumbs: PageSeoBreadcrumbsResolver,
    },
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PageSeoRoutingModule {}
